export default __webpack_public_path__ + "static/media/basketball-icon-blue.d3c2b971.svg";